import { useCallback, useEffect } from 'react'

import useCurrentUser from '~/hooks/useCurrentUser'
import { setStoryCardIdActionCreator } from '~/redux/slices/story-card'
import { StoryCardId } from '~/types/storyCard'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { EventStatus, EventType } from '~/gamification/types/gamification.types'
import { selectChampionshipStoryCardEventId } from '~/gamification/utils/gamification.utils'

import { userHasAllRequiredFields } from '~/auth/utils/register.utils'

import { selectEvents } from '~/gamification/slices/gamification.slice'
import { useUpdateEventDataMutation } from '~/redux/apis/reward-api'

export function useStoryCards(): void {
  const events = useAppSelector(selectEvents)
  const hasFetched = Boolean(events)
  const user = useCurrentUser()
  const userExists = userHasAllRequiredFields(user)
  const dispatch = useAppDispatch()

  const isReadyToDispatchEvent = userExists && hasFetched

  const [updateEventsData] = useUpdateEventDataMutation()

  const handleStoryCardEvent = useCallback(
    (eventId: StoryCardId, special = false): void => {
      if (special) {
        dispatch(setStoryCardIdActionCreator(eventId))
        return
      }
      const foundEvent = events?.find((event) => event.id === eventId)

      if (!foundEvent || foundEvent.status === EventStatus.PENDING) {
        dispatch(setStoryCardIdActionCreator(eventId))
      }

      if (!foundEvent) {
        updateEventsData([{ id: eventId, type: EventType.PET, status: EventStatus.PENDING }])
      }
    },
    [events, updateEventsData, dispatch],
  )

  /**
   * Firing Event for championship
   */
  useEffect(() => {
    if (!isReadyToDispatchEvent) return
    const filteredEvent = events?.find(
      (event) => event.type === EventType.CHAMPIONSHIP && event.status === EventStatus.PENDING,
    )
    if (filteredEvent) {
      handleStoryCardEvent(selectChampionshipStoryCardEventId(filteredEvent), true)
    }
  }, [events, isReadyToDispatchEvent, handleStoryCardEvent])
}
